import { isAnyArray } from 'is-any-array';
import { xMean, xMaxValue, xMinValue } from 'ml-spectra-processing';
export function rollingBall(spectrum, options = {}) {
    if (!isAnyArray(spectrum)) {
        throw new Error('Spectrum must be an array');
    }
    if (spectrum.length === 0) {
        throw new TypeError('Spectrum must not be empty');
    }
    const numberPoints = spectrum.length;
    const maxima = new Float64Array(numberPoints);
    const minima = new Float64Array(numberPoints);
    const baseline = new Float64Array(numberPoints);
    // windowM 4 percent of spectrum length
    // windowS 8 percent of spectrum length
    const { windowM = Math.round(numberPoints * 0.04), windowS = Math.round(numberPoints * 0.08), } = options;
    // fi(1) in original paper
    for (let i = 0; i < spectrum.length; i++) {
        let windowLeft = Math.max(0, i - windowM);
        let windowRight = Math.min(i + windowM + 1, spectrum.length);
        minima[i] = xMinValue(spectrum, {
            fromIndex: windowLeft,
            toIndex: windowRight,
        });
    }
    // fi in original paper
    for (let i = 0; i < minima.length; i++) {
        let windowLeft = Math.max(0, i - windowM);
        let windowRight = Math.min(i + windowM + 1, minima.length);
        maxima[i] = xMaxValue(minima, {
            fromIndex: windowLeft,
            toIndex: windowRight,
        });
    }
    for (let i = 0; i < minima.length; i++) {
        let windowLeft = Math.max(0, i - windowS);
        let windowRight = Math.min(i + windowS + 1, maxima.length);
        baseline[i] = xMean(maxima.subarray(windowLeft, windowRight));
    }
    return baseline;
}
//# sourceMappingURL=rollingBall.js.map